import { IAlertConfig } from '../../../models/bootstrap/Alert' 
import { BusinessArea } from '../../../services/AuthService';
import { AirportModalController } from './AirportModalController';
import _ from 'lodash-es';

interface WorkQueueParams {
    page: number;
    pageSize: number;
    orderBy: string;
    descending: boolean;
}

export class AirportsController {
    airports;

    editFrom;

    alerts: IAlertConfig[] = []
    $dirty: boolean;

    public airportsPage: { airports: any[], totalCount:number};
    params: WorkQueueParams;
    loading: boolean = false;

    selections: any[];
    selectedGridItems: any[];

    pageSizes: number[] = [50, 100, 500, 1000];
    lastPage: number;

    allSelected: boolean;

    static $inject = ['$scope', 'Auth', 'Spinner', '$q', '$state', 'dialogs', '$uibModal', 'GridExport', 'Airport'];
    constructor(private $scope, private Auth, private Spinner, private $q, private $state, private dialogs, private $uibModal, private GridExport, private Airport) {

        this.selections = [];
        this.selectedGridItems = [];

        this.params = {
            page: 0,
            pageSize: 50,
            orderBy: 'airportName',
            descending: false
        };

        $scope.$watch(() => this.selectedGridItems, (values) => {
            if (values.length > 0 && values[0]) {
                this.editAirport(values[0]);
                this.selectedGridItems = [];
            }
        }, true); 

    }

    getAirports(currentPage, pageItems, filterBy, filterByFields, orderBy, descending) {
        this.params.page = currentPage;
        this.params.pageSize = pageItems;
        if (orderBy) {
            this.params.orderBy = orderBy;
            this.params.descending = descending;
        } else {
            this.params.orderBy = 'airportName';
            this.params.descending = false;
        }

        this.refresh();
    }


    refresh() {
        this.loading = true;

        new this.Airport.query(this.params, (result) => {
            this.airportsPage = result;

            this.lastPage = Math.floor(this.airportsPage.totalCount / this.params.pageSize);

            this.selections = [];

            this.loading = false;
            this.$scope.$broadcast("grid_refresh");
        }, () => {
            this.loading = false;
        });
    }

    addAirport() {
        this.$uibModal.open({
            templateUrl: 'areas/tools/maintainFlights/airportModal.html',
            controller: AirportModalController,
            controllerAs: '$ctrl',
            backdrop: false,
            resolve: {
                airportInfo: {}
            }
        }).result.then(() => {
            this.refresh();
        });
    }

    editAirport(airportInfo) {

        this.$uibModal.open({
            templateUrl: 'areas/tools/maintainFlights/airportModal.html',
            controller: AirportModalController,
            controllerAs: '$ctrl',
            backdrop: false,
            resolve: {
                airportInfo: this.Airport.get({ airportCode: airportInfo.airportCode }).$promise
            }
        }).result.then(() => {
            this.refresh();
        });
    }

    //public export() {
    //    this.GridExport.saveAsCSV('.airportTable', 'export.csv', this.selections.length != 0)
    //}

    public closeAlert(index: number) {
        this.alerts.splice(index, 1)
    }

    toggleAllSelected() {
        this.allSelected = !this.allSelected;
        this.allSelectedChange();
    }

    allSelectedChange() {

        this.selections = [];
        if (this.allSelected) {
            for (let entry of this.airportsPage.airports) {
                entry.checked = true;
                this.selections.push(entry);
            }
        } else {
            for (let entry of this.airportsPage.airports) {
                entry.checked = false;
            }
        }
    }

    toggleItem(item) {
        item.checked = !item.checked;
        this.itemChanged(item);
    }

    itemChanged(item) {
        if (item.checked) {
            let serach = {
                airportCode: item.airportCode
            };
            if (!_.includes(this.selections, serach)) {
                this.selections.push(item);

                for (let entry of this.airportsPage.airports) {
                    if (!entry.checked) {
                        return
                    }
                }
                this.allSelected = true;
            }
        } else {
            this.allSelected = false;
            _.remove(this.selections, (value) => value.airportCode === item.airportCode);
        }
    }

    changePageSize() {
        this.lastPage = Math.floor(this.airportsPage.totalCount / this.params.pageSize);
        this.refresh();
    }

    goFirstPage() {
        if (this.params.page > 0) {
            this.params.page = 0;
        }
    }
    goPrevPage() {
        if (this.params.page > 0) {
            this.params.page = this.params.page - 1;
        }
    }
    goNextPage() {
        if (this.params.page < this.lastPage) {
            this.params.page = this.params.page + 1;
        }
    }
    goLastPage() {
        if (this.params.page < this.lastPage) {
            this.params.page = this.lastPage;
        }
    }
}


angular
    .module('app')
    .controller('AirportsController', AirportsController);